<template>
  <div class="accountant-form">
    <el-form
      ref="form"
      v-loading="loading"
      :model="form"
      :rules="rules"
      label-width="120px"
      style="overflow: auto"
    >
      <div style="text-align: right">
        <el-button
          size="small"
          style="background: cornflowerblue; color: white"
          :loading="printing"
          @click="print"
        >打印<span v-if="printing">中...</span></el-button>
      </div>
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="出仓单信息" name="first">
          <el-scrollbar>
            <div class="table-form">
              <p class="onetitle">出 仓 单</p>
              <div class="form-logo">
                <div><img :src="form.logoInfo.logoUrl" alt=""></div>

                <div>
                  <p class="fCompany">
                    {{ form.logoInfo.fCompany }}
                  </p>
                  <p class="fCompanyEnglish">
                    {{ form.logoInfo.fCompanyEnglish }}
                  </p>
                </div>
              </div>
              <div class="form-info">
                <p>提货部门：{{ form.stockInfo.fBillingName }}</p>
                <p>
                  客户名称：{{ form.stockInfo.fCustomer
                  }}<span>NO：{{ form.stockInfo.fBillNo }}</span><span>日期：{{ form.stockInfo.fCreateTime }}</span>
                </p>
              </div>
              <el-table
                :data="pTableData"
                border
                :span-method="objectSpanMethod"
                style="width: 100%"
                @cell-click="clo"
              >
                <el-table-column prop="fNumber" label="产品编号" width="" />
                <el-table-column prop="fName" label="品名" width="" />
                <el-table-column prop="fModel" label="规格" width="" />
                <el-table-column prop="fUnit" label="单位" width="" />
                <el-table-column prop="fQty" label="数量" width="" />
                <el-table-column prop="fDate_Sc" label="生产日期" width="" />
                <el-table-column prop="fBatchNo" label="生产批号" width="" />
                <el-table-column prop="fDate_Xd" label="消毒日期" width="" />
                <el-table-column prop="fDate_fh" label="发货日期" width="" />
                <el-table-column prop="fDes" label="备注" width="" />
              </el-table>
              <div class="form-foot">
                <span>记账：{{ form.stockInfo.jz }}</span><span>会计：{{ form.stockInfo.kj }}</span><span>出纳：{{ form.stockInfo.cn }}</span><span>部门主管：{{ form.stockInfo.bmzg }}</span><span>保管：{{ form.stockInfo.bg }}</span><span>提货人：{{ form.stockInfo.thr }}</span>
              </div>
              <p style="text-align: right; font-weight: bold; font-size: 14px">
                {{ form.stockInfo.fControlledNumber }}
              </p>
            </div>
          </el-scrollbar>
        </el-tab-pane>

        <el-tab-pane label="订单信息" name="second">
          <el-scrollbar>
            <el-table :data="form.entrys">
              <el-table-column label="产品编号" prop="fNumber" />
              <el-table-column label="产品名称" prop="fName" />
              <el-table-column label="规格" prop="fModel" />
              <el-table-column label="单位" prop="fUnit" />
              <el-table-column label="数量" prop="fQty" />
              <el-table-column prop="fPrice" label="单价" width="" />
              <el-table-column label="小计" prop="total" />
              <el-table-column label="备注" prop="fDes" />
            </el-table>
            <div style="text-align:right;padding-right:18%;margin-top:10px;">
              合计:{{ total }}
            </div>
            <hr>
            <div style="text-align:right;padding-right:18%;margin-bottom:3%;">
              付款比例:{{ form.fDeductionRatio }}%
              付款金额:{{ totalRatio }}
            </div>
          </el-scrollbar>
        </el-tab-pane>
        <el-tab-pane v-if="!isNew" label="单据流程" name="third">
          <el-table :data="form.procedureMessage" height="100%">
            <el-table-column label="流程步骤" prop="fName" />
            <el-table-column label="处理人" prop="fUserName" />
            <el-table-column label="状态" prop="fState" />
            <el-table-column
              label="日期"
              prop="fDate"
              :formatter="dateFormat"
            />
            <el-table-column label="意见" prop="fOpinion" />
          </el-table>
        </el-tab-pane>
        <el-tab-pane v-if="canAudit" label="确认" name="four">
          <el-form
            ref="form"
            v-loading="loading"
            :model="form"
            :rules="rules"
            label-width="78px"
            style="overflow: auto"
          >
            <el-form-item
              v-if="canAudit"
              label="审批意见"
              style="margin-top: 10px"
              class="formitem"
            >
              <el-input
                v-model="form.procedureInfo.fOpinion"
                type="textarea"
                rows="4"
                style="width: 100%"
              />
            </el-form-item>
          </el-form>
          <el-button
            v-if="canAudit"
            type="primary"
            :disabled="saving"
            style="margin-left: 78px"
            @click="submit(1)"
          >通过</el-button>
          <el-button
            v-if="canAudit"
            type="warning"
            :disabled="saving"
            style=""
            @click="submit(2)"
          >回退</el-button>
        </el-tab-pane>
      </el-tabs>
      <iframe
        style="display: none"
      ><Print id="printVoucher1" ref="printVoucher1"></Print
        ></iframe>
      <iframe
        style="display: none"
      ><Print2 id="printVoucher2" ref="printVoucher2"></Print2
        ></iframe>
    </el-form>
  </div>
</template>

<script>
import { Now, Today, DeepCopy } from '@assets/site'
import moment from 'moment'
import ReturnNode from '@components/ReturnNode'
import Print from '../commonPrint/Print.vue'
import Print2 from '../commonPrint/Index.vue'
import printnb from '@plugins/vue-print-nb-printarea'

export default {
  inject: ['getMap'],
  components: {
    Print, Print2
  },
  data: function() {
    return {
      form: {
        procedureInfo: {},
        entrys: [],
        logoInfo: {},
        procedureMessage: [],
        stockInfo: {}
      },
      pTableData: [],
      rules: {},

      activeName: 'first',

      saving: false,
      loading: false,
      isNew: false,
      printing: false
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.routePath || vm.routePath != to.fullPath) {
        vm.routePath = to.fullPath
        vm.refresh()
      }
    })
  },
  beforeRouteUpdate: function(to, from, next) {
    next()
    const vm = this
    vm.routePath = to.fullPath
    vm.refresh()
  },
  computed: {
    canAudit: function() {
      // console.log(this.form, "this.form");

      if (this.form) {
        if (this.form.readOnly == false) {
          return true
        }
      }
      return false
    },
    total: function() {
      var t = this.form.entrys.reduce((sum, item) => {
        return Number(sum) + Number(item.total)
      }, 0)
      return t.toFixed(2)
    },
    totalRatio: function() {
      var t = this.form.entrys.reduce((sum, item) => {
        return Number(sum) + Number(item.total)
      }, 0)
      return (t * Number(this.form.fDeductionRatio) / 100).toFixed(2)
    }
  },
  mounted() {},
  methods: {
    submit: function(type) {
      // console.log(this.$store.state.tabName, 'store')
      this.$refs.form.validate(async(valid) => {
        if (valid) {
          this.form.procedureInfo.fType = type
          if (type == 2) {
            if (!this.form.procedureInfo.fOpinion) {
              this.$message.error('请填写审核意见')
              return
            }
            const h = this.$createElement
            this.form.procedureInfo.returnNode = await new Promise(
              (resolve, reject) => {
                this.$formDlg({
                  title: '选择回退节点',
                  formTpl: <ReturnNode name={'Order_kj_s'}></ReturnNode>,
                  formSubmit: resolve,
                  width: '30%'
                })
              }
            )
          } else {
            this.form.procedureInfo.returnNode = null
          }

          const flg = await this.confirm('是否提交?')
          if (!flg) return

          this.saving = true
          this.form.stockInfo.stockEntrys.splice(-2, 2)
          this.$httpPost('OrderManage/OrderForKj/OrderForKjApproval', {
            datalist: JSON.stringify(this.form)
          })
            .then((res) => {
              if (!res.isSuccess) {
                this.$message.error(res.message)
                return
              }

              // 重新刷新页面数据
              this.$message.success(res.message)
              // if (res.datalist) this.refresh(res.datalist);

              if (this.$route.query.ishome) {
                const tabName = this.$store.state.tabName
                this.getMap(tabName)
                this.$router.push({ path: '/' })
              } else {
                const tabName = this.$store.state.tabName
                this.getMap(tabName)
                this.$router.push({ path: '/orderManage/accountantAudit' })
              }
            })
            .finally(() => (this.saving = false))
        } else {
          this.activeName = 'first'
          return false
        }
      })
    },
    refresh: async function(fid) {
      const id = fid || +this.$route.params.id
      this.isNew = !id
      if (id == 0) {
        this.form = {
          procedureInfo: {},
          entrys: []
        }
        return
      }

      this.loading = true
      const res = await this.$httpPost('OrderManage/OrderForKj/GetOrderForKj', {
        fid: id
      }).finally(() => (this.loading = false))

      if (!res.isSuccess) {
        this.$message.error(res.message)
        return
      }

      this.form = res.datalist
      this.pTableData = this.form.stockInfo.stockEntrys
      const newob1 = Object.assign({
        fNumber: '备注1',
        fName: this.form.stockInfo.des1
      })
      const newob2 = Object.assign({
        fNumber: '备注2',
        fName: this.form.stockInfo.des2
      })
      this.pTableData.push(newob1, newob2)
      // console.log(this.pTableData, 'this.pTableData')
      const fCreateTimes = res.datalist.stockInfo.fCreateTime
      if (fCreateTimes == undefined || fCreateTimes == 'Invalid date') {
        this.form.fDate = ''
      }
      this.form.stockInfo.fCreateTime = moment(fCreateTimes).format(
        'YYYY/MM/DD HH:mm:ss'
      )
    },
    confirm: function(msg) {
      return this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => true)
        .catch(() => false)
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // console.log(rowIndex, 'rowIndex')
      // console.log(columnIndex, 'columnIndex')
      const rowlength1 = this.pTableData.length - 1
      const rowlength2 = this.pTableData.length - 2
      if (rowIndex === rowlength2) {
        if (columnIndex === 1) {
          return [1, 9]
        }
      }
      if (rowIndex === rowlength1) {
        if (columnIndex === 1) {
          return [1, 9]
        }
      }
      // if (columnIndex === 0) {
      //   if (rowIndex === rowlength2) {
      //     return {
      //       rowspan: 2, // 多少行合并
      //       colspan: 1, // 多少列合并
      //     };
      //   }
      // }
    },
    clo(row, column, cell, event) {
      // console.log(row, 'row')
      // console.log(column, 'column')
      // console.log(cell, 'cell')
      // console.log(event, 'event')
    },
    //    日期格式转换
    dateFormat: function(row, column, cellValue) {
      const date = cellValue
      if (date == undefined || date == 'Invalid date') {
        return ''
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    print: async function() {
      // this.$router.push({ path: '/orderManage/commonPrint' })
      this.printing = true
      let printversion
      let success
      const fControlledNumber = this.form.stockInfo.fControlledNumber
      console.log(this.form, 'form')
      // 旧的打印模块
      if (fControlledNumber == 'SS-FOR-08-04B' || fControlledNumber == 'WYJK-QPR-04-01A') {
        printversion = 'printVoucher2'
        success = await this.$refs.printVoucher2.refresh(this.form.fid)
      } else { // 新的打印模块
        printversion = 'printVoucher1'
        success = await this.$refs.printVoucher1.refresh(this.form.fid)
      }
      if (!success) {
        this.printing = false
        return
      }
      // https://www.npmjs.com/package/vue-print-nb
      new printnb({
        ids: printversion, // * 局部打印必传入id
        standard: '', // 文档类型，默认是html5，可选 html5，loose，strict
        extraHead: '', // 附加在head标签上的额外标签,使用逗号分隔
        extraCss: '', // 额外的css连接，多个逗号分开
        popTitle: '', // title的标题
        endCallback() {
          // 调用打印之后的回调事件
        }
      })
      setTimeout(() => {
        this.printing = false
      }, 100)
    }
  }
}
</script>

<style lang="less" scoped>
</style>
<style lang="less">
.accountant-form {
  .el-scrollbar {
    height: 100%;
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .el-input.is-disabled .el-input__inner {
    background-color: #f5f7fa;
    border-color: #e4e7ed;
    color: #000;
    cursor: not-allowed;
  }
  .el-tabs {
    .el-tabs__content {
      height: calc(100vh - 200px);
      .el-tab-pane {
        height: calc(100vh - 200px);
      }
    }
  }
  .formitem {
    .el-form-item__label {
      margin: 26px 0;
      // width: 78px !important;
    }
    .el-form-item__content {
      // margin-left: 89px !important;
    }
  }

  .table-form {
    width: 99%;
    table {
      font-size: 12px;
    }
    .el-table {
      color: #000;
    }
    .el-table td,
    .el-table th {
      // padding: 0px 0;
    }
    .el-table__header tr,
    .el-table__header th {
      padding: 0;
    }
    .el-table td,
    .el-table th.is-leaf,
    .el-table--border,
    .el-table--group {
      border-color: black;
    }
    .el-table--border::after,
    .el-table--group::after,
    .el-table::before {
      background-color: black;
    }
    .el-table thead {
      color: #000;
      font-weight: 500;
    }
    .onetitle {
      font-weight: bold;
      font-size: 25px;
      font-family: 华文行楷;
      text-align: center;
      margin: 0;
    }
    .form-logo {
      display: flex;
      div {
        flex-direction: column;
      }

      p {
        margin: 0px;
      }
      .fCompany {
        height: 40px;
        line-height: 40px;
        font-size: 13px;
      }
      .fCompanyEnglish {
        font-size: 7px;
        height: 8px;
      }
    }
    .form-info {
      font-size: 14px;
      span {
        float: right;
        // text-align: right;
        margin-left: 35px;
      }
    }
    .form-foot {
      display: flex;
      font-size: 14px;
      margin-top: 5px;
      span {
        flex: 1;
        //  flex-direction:column;
        justify-content: space-between;
      }
    }
  }
}
</style>
